import { useInversionFlags } from '../../../../hooks/useInversionFlags'
import { getConditionResult } from '../../../../utils/rule-builder-util'
import { RuleType } from '../../../../utils/types'
import RuleTypeRenderer from '../../RuleBuilder/RuleTypeRenderer'
import ConditionalDefaultBlock from '../ConditionalDefaultBlock'

const ConditionalInversionBlock = (props: any) => {
  const { filteredConditionals, isEditor, resultsFalse, componentTypeRenderer, defaultConditional } = props
  const { inversionProperties, isLocal } = useInversionFlags()

  let result
  for (const condition of filteredConditionals) {
    const { ruleExpression, resultsTrue = {}, ruleId, ruleType } = condition

    const displayInversionComponent = () => {
      if (ruleType === RuleType.conditional) {
        return getConditionResult(ruleExpression, {}, 0, isLocal, inversionProperties)
      } else if (ruleType === RuleType.udoconditional) {
        return ruleExpression
      }
      return false
    }

    if (displayInversionComponent()) {
      result = (
        <RuleTypeRenderer
          ruleId={ruleId}
          resultsTrue={resultsTrue}
          resultsFalse={resultsFalse}
          ruleType={ruleType}
          condition={condition}
          ruleExpression={ruleExpression}
          isInEditor={isEditor}
          componentTypeRenderer={componentTypeRenderer}
          compName={props?.compName}
        />
      )
    }
  }

  return result ?? <ConditionalDefaultBlock isInEditor={isEditor} defaultConditional={defaultConditional} {...props} />
}

export default ConditionalInversionBlock
